import React, { useEffect, useState } from "react";
import { RESTExecutor, withDomains } from "../lib/domain"
import  {CloseOutlined}  from '@material-ui/icons';
import moment from 'moment';

const ExpiryView =({...props})=>{
  
    useEffect(()=>{
        get_license_info.execute();
    },[]);


    let get_license_info=RESTExecutor.detail().config({
        label:'license_info'
    })
    .callbacks((success)=>{
        let res=success.result??{};

        let expDate=moment(res.expiry_date,"YYYY-MM-DD");
        if(expDate.diff(moment())<30 && checkShowFromLocalStorage()){
            setShoudShowWarning(true);
        }
        console.log("response is",res,expDate.diff(moment(),'days'));
    })
    .connect(props.domains.system);

    const hideWarning=()=>{
        localStorage.setItem("hdFor",moment().format("YYYY-MM-DD"));
        setShoudShowWarning(false);
    }

    const checkShowFromLocalStorage=()=>{
        let val = localStorage.getItem("hdFor");
        if(val){
            return val!==moment().format("YYYY-MM-DD");
        }else{
            return true;
        }
    }

    const [shouldShowWarning,setShoudShowWarning]=useState(false);

    let resp=get_license_info.response();
    let data=resp.result??{};
    let expDate=moment(`${data.expiry_date} 23:59`,"YYYY-MM-DD HH:mm");
    let countData=expDate.diff(moment(),'days',false);       
    return !shouldShowWarning?null:<div style={{
        height:40,
        backgroundColor:'red',
        color:'white',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        fontSize:'16px',
        position:'relative',
    }}>
        {countData>-1?<>
        Your license is expiring on <strong>&nbsp;{`${countData} days (${data.expiry_date})`}</strong>. Please contact the Vendor for upgrading the license by clicking <a href="mailto:support@gokyolabs.com">&nbsp;here</a>.
        </>:
        <>
        Your license has expired on <strong>&nbsp;{`${data.expiry_date}`}</strong>. Please contact the Vendor for upgrading the license by clicking <a href="mailto:support@gokyolabs.com">&nbsp;here</a>.
        </>}
        <div  style={{
            position:'absolute',
            right:8,
            top:8
        }}>
            <CloseOutlined onClick={()=>hideWarning()} />
        </div>
    </div>
}

export default withDomains(ExpiryView,"system");